function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import AbstractInput from '../AbstractInput';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * DEPRECATED! Will be removed in v1. Use TextInputBox component instead.
 * The TextInput component provides a single line text input form element with the
 * option to persist the placeholder label
 *
 * - [MDN docs for input[type="text"]](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/text)
 *
 * ## Related Components
 *
 * - [TextArea](../TextArea/README.md)
 * - [Label](../Label/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <TextInput
 *   variant="underline"
 *   placeholder="Type Something"
 *   persistPlacholder
 * />
 *```
 *
 * ## Props
 */

var TextInput = /*#__PURE__*/function (_AbstractInput) {
  _inherits(TextInput, _AbstractInput);

  var _super = _createSuper(TextInput);

  function TextInput() {
    _classCallCheck(this, TextInput);

    return _super.apply(this, arguments);
  }

  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          className = _this$props.className,
          type = _this$props.type,
          placeholder = _this$props.placeholder,
          persistPlaceholder = _this$props.persistPlaceholder,
          variant = _this$props.variant,
          disabled = _this$props.disabled,
          value = _this$props.value,
          onChange = _this$props.onChange;
      var isFocused = this.state.isFocused;
      var isActivated = (value || '').trim() !== '';

      var _TextInput$getClassNa = TextInput.getClassName({
        className: className,
        persistPlaceholder: persistPlaceholder,
        variant: variant,
        isActivated: isActivated,
        isFocused: isFocused,
        disabled: disabled
      }),
          root = _TextInput$getClassNa.root,
          control = _TextInput$getClassNa.control,
          placeholderClass = _TextInput$getClassNa.placeholder;

      var inputId = id || this.id;
      return /*#__PURE__*/React.createElement("label", {
        htmlFor: inputId,
        className: root
      }, /*#__PURE__*/React.createElement("span", {
        className: placeholderClass
      }, placeholder), /*#__PURE__*/React.createElement("input", {
        className: control,
        id: inputId,
        type: type,
        value: value,
        disabled: disabled,
        onChange: onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }));
    }
  }]);

  return TextInput;
}(AbstractInput);

TextInput.defaultProps = {
  className: '',
  id: null,
  // html5 attributes
  type: 'text',
  placeholder: '',
  disabled: false,
  value: '',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  // design attributes
  variant: '',
  persistPlaceholder: false
};
TextInput.propTypes = {
  /**
   * The id tying the labels to the input control. If not provided
   * one will be created
   */
  id: PropTypes.string,

  /**
   * Whether to always show the placeholder text
   */
  persistPlaceholder: PropTypes.bool,

  /**
   * event callback to be called when text control is focused
   */
  onFocus: PropTypes.func,

  /**
   * event callback to be called when text control is blurred / loses focus
   */
  onBlur: PropTypes.func,

  /**
   * event callback to be called when text is entered or removed from the control
   */
  onChange: PropTypes.func,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Whether the radio is initially checked
   */
  variant: PropTypes.string,

  /**
   * The Typed in text
   */
  value: PropTypes.string,

  /**
   * Type of text input
   */
  type: PropTypes.oneOf(['text', 'password']),

  /**
   * The placeholder text to show when no text has been inputted
   */
  placeholder: PropTypes.string,

  /**
   * Whether or not the user is able to use the control
   */
  disabled: PropTypes.bool
};

TextInput.getClassName = function (_ref) {
  var variant = _ref.variant,
      isActivated = _ref.isActivated,
      isFocused = _ref.isFocused,
      disabled = _ref.disabled,
      persistPlaceholder = _ref.persistPlaceholder,
      className = _ref.className;
  return {
    root: cx('psw-text-input', _defineProperty({}, "psw-text-input-".concat(variant), !!variant), {
      'psw-p-x-s': variant === 'block'
    }, {
      'psw-underlined': variant === 'underline'
    }, {
      'psw-is-active': isActivated
    }, {
      'psw-is-disabled': disabled
    }, {
      'psw-is-focused': isFocused
    }, {
      'psw-is-placeholder-persisted': !!persistPlaceholder
    }, className),
    control: cx('psw-text-input__control'),
    placeholder: cx('psw-text-input__label', 'psw-v-center', 'psw-c-secondary', {
      'psw-body-3': isActivated && persistPlaceholder
    }, {
      'psw-hide': isActivated && !persistPlaceholder
    }, {
      'psw-body-1': !isActivated
    }, {
      'psw-p-l-s': variant === 'block'
    })
  };
};

TextInput.useClassNames = function (x) {
  TextInput.classNames = x;
};

cx = classNamesFor(TextInput);
export default TextInput;